import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch";
import { primaryColor } from './material-dashboard-pro-react';

export const buttonGroupStyle = {
  buttonGroup: {
    position: 'relative',
    margin: '10px 1px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid lightgray',
    borderRadius: 50,
    width: '100%'
  },
  firstButton: {
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    margin: '0',
    padding: 15,
    position: 'relative',
    width: '100%',
    float: 'left',
    '&:hover': {
      zIndex: '2',
    },
    "@media (min-width: 768px)": {
      padding: '10px 30px',
    }
  },
  middleButton: {
    borderRadius: '0',
    margin: '0',
    padding: 15,
    position: 'relative',
    width: '100%',
    float: 'left',
    '&:hover': {
      zIndex: '2',
    },
    '& span>span': {
      display: 'none',
      "@media (min-width: 768px)": {
        display: 'inherit',
        marginLeft: 3
      }
    },
    "@media (min-width: 768px)": {
      padding: '10px 30px',
    }
  },
  lastButton: {
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    margin: '0',
    width: '100%',
    padding: 15,
    '&:hover': {
      zIndex: '2',
    },
    '& span>span': {
      display: 'none',
      "@media (min-width: 768px)": {
        display: 'inherit',
        marginLeft: 3
      }
    },
    "@media (min-width: 768px)": {
      padding: '10px 30px',
    }
  },
};

const switchBar = {
  switchBar: {
    width: '52px',
    height: '26px',
    marginTop: '-13px',
    borderRadius: '20px',
    marginLeft: '-27px',
    backgroundColor: '#b7bdbf',
    opacity: '1 !important',
  },
  switchIcon: {
    border: 'none',
    backgroundColor: 'white',
    width: '23px',
    height: '23px',
    transform: 'translateX(-7px)'
  },
  switchIconChecked: {
    transform: 'translateX(4px)'
  },
};

const FilterStyles = {
  ...customCheckboxRadioSwitch,
  ...switchBar,
  ...buttonGroupStyle,
  buttonGroup: {
    ...buttonGroupStyle.buttonGroup,
    '@media (max-width: 767px)': {
        border: 0,
        flexWrap: 'wrap',
    }
  },
  firstButton: {
    ...buttonGroupStyle.firstButton,
    '@media (max-width: 767px)': {
      borderTopRightRadius: 30,
      borderBottomRightRadius: 30,
    },
  },
  middleButton: {
    ...buttonGroupStyle.middleButton,
    '@media (max-width: 767px)': {
      borderRadius: 30,
    }
  },
  lastButton: {
    ...buttonGroupStyle.lastButton,
    '@media (max-width: 767px)': {
      borderTopLeftRadius: 30,
      borderBottomLeftRadius: 30,
    }
  },
  section: {
    marginBottom: 32,
    "@media (min-width: 768px)": {
      marginBottom: 20,
    }
  },
  categorySection: {
    "@media (min-width: 768px)": {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 4px'
    }
  },
  title: {
    lineHeight: 1
  },
  categoryDD: {
    marginBottom: 8,
    '&:before, &:after': {
      display: 'none'
    },
    '& svg': {
      display: 'none'
    },
    "@media (min-width: 768px)": {
      marginBottom: 0,
    }
  },
  select: {
    border: '1px solid #2DAAF2',
    borderRadius: 8,
    padding: '8px 16px',
    marginRight: 8,
    fontSize: 14,
    color: '#2DAAF2',
    fontWeight: 400,
    '&:hover': {
      color: primaryColor,
      border: `1px solid ${primaryColor}`,
    },
    '&:focus': {
      borderRadius: 8
    },
    "@media (min-width: 768px)": {
      marginLeft: 8,
    }
  },
  userSelect: {
    border: '1px solid lightgray',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 10px 8px 15px',
    transition: 'all .2s ease',
    width: '100%',
    '& button': {
      padding: 0,
    },
    '& svg': {
      fill: '#2ea9f2',
    },
    '& .title': {
      marginBottom: 2,
      fontWeight: 400,
      color: '#2DAAF2',
      textAlign: 'left',
    },
    '& .user': {
      fontWeight: 500,
      textTransform: 'uppercase',
      fontSize: '0.8em',
      color: '#2DAAF2',
      margin: '8px 0 0'
    }
  },
  userSelected:{
    border: '1px solid #2DAAF2',
    backgroundColor: '#2DAAF2',
    '& svg': {
      fill: 'white',
    },
    '& .title': {
      color: 'white',
    },
    '& .user': {
      color: 'white',
    }
  },
  selectRev: {
    margin: 0
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  statusChecks: {
    width: '100%'
  },
  userSection: {
    justifyContent: 'space-between',
    "@media (max-width: 767px)": {
      display: 'block',
    }
  },
  reviewDD: {
    width: '100%',
    '&:before, &:after': {
      display: 'none'
    },
    '& svg': {
      right: 15,
    },
    "@media (min-width: 768px)": {
      margin: '0 -8px',
    }
  },
  reviewSection: {
    margin: '32px 0',
    "@media (min-width: 768px)": {
      margin: '21px 0 40px'
    }
  },
  disabledContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 1,
    opacity: .8
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  collapsedFilterTag: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #2DAAF2',
    color: '#2DAAF2',
    borderRadius: 20,
    marginBottom: 4,
    marginRight: 4,
    padding: '2px 8px',
    fontWeight: 400,
    position: 'relative',
    overflow: 'hidden',
    cursor: 'default',
    textTransform: 'capitalize',
    '& .clear': {
      transition: 'transform .3s ease',
      margin: 0,
      marginRight: -8,
      padding: 0,
      height: '20px !important',
      "@media (min-width: 767px)": {
        position: 'absolute',
        right: 0,
        marginRight: 0,
        top: 3,
        transform: 'translateX(80px)'
      }
    },
    '&:hover .clear': {
      "@media (min-width: 767px)": {
        transform: 'translateX(0px)'
      }
    },
  },
  showFilters: {
    marginBottom: '-10px',
    "@media (min-width: 767px)": {
      marginTop: -5,
    }
  },
  backColor: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'white'
  },
  animationFilter: {
    transition: 'all .2s ease',
  },
  expandFilters: {
    maxHeight: 3000,
    opacity: 1,
    paddingTop: 16,
    paddingBottom: 8,
    borderBottom: '1px solid #ddd',
    "@media (min-width: 767px)": {
      maxHeight: 1080,
    }
  },
  collapseFilters: {
    maxHeight: 40,
    opacity: 0
  },
  expandCollapsedFilters: {
    maxHeight: 200,
    opacity: 0
  },
  collapseCollapsedFilters: {
    maxHeight: 'auto',
    opacity: 1,
    margin: -15,
  },
  checked: {
    height: 34,
    width: 34,
    color: '#007eb5 !important'
  },
  locationTitle: {
    width: '100%',
    padding: '10px 0px 0px 10px'
  },
  adModalConfirmation: {
    '& h2': {
        margin: '0 0 10px',
        fontSize: 28,
        fontWeight: 500,
    }
  }
};

export default FilterStyles;
